import { connect } from 'react-redux';
import AutoReplenishmentActions from 'actions/AutoReplenishmentActions';
import beautyInsiderActions from 'actions/BeautyInsiderActions';
import AddressActions from 'actions/AddressActions';
import FrameworkUtils from 'utils/framework';
import AutoReplenishmentBindings from 'analytics/bindingMethods/pages/myAccount/AutoReplenishmentBindings';
import Actions from 'actions/Actions';

/**
 * HOC that injects AutoReplenishment action dispatchers into the wrapped component.
 */
const { wrapHOC } = FrameworkUtils;

const functions = {
    showInterstice: Actions.showInterstice,
    showConfirmCVVModal: Actions.showConfirmCVVModal,
    loadSubscriptions: AutoReplenishmentActions.loadSubscriptions,
    updateActiveSubscriptions: AutoReplenishmentActions.updateActiveSubscriptions,
    updatePausedSubscriptions: AutoReplenishmentActions.updatePausedSubscriptions,
    updateCancelledSubscriptions: AutoReplenishmentActions.updateCancelledSubscriptions,
    openFAQModal: AutoReplenishmentActions.openFAQModal,
    unsubscribeAutoReplenishment: AutoReplenishmentActions.unsubscribeAutoReplenishment,
    pauseAutoReplenishment: AutoReplenishmentActions.pauseAutoReplenishment,
    skipAutoReplenishment: AutoReplenishmentActions.skipAutoReplenishment,
    openConfirmUnsubscribeModal: AutoReplenishmentActions.openConfirmUnsubscribeModal,
    openConfirmPausedSubscriptionModal: AutoReplenishmentActions.openConfirmPausedSubscriptionModal,
    updateAutoReplenishmentSubscription: AutoReplenishmentActions.updateAutoReplenishmentSubscription,
    fetchClientSummary: beautyInsiderActions.fetchClientSummary,
    removeCreditCard: AutoReplenishmentActions.removeCreditCard,
    setDefaultCCOnProfileAndDelete: AutoReplenishmentActions.setDefaultCCOnProfileAndDelete,
    resumeAutoReplenishment: AutoReplenishmentActions.resumeAutoReplenishment,
    manageUnsubscribe: AutoReplenishmentBindings.manageUnsubscribe,
    pauseConfirmation: AutoReplenishmentBindings.pauseConfirmation,
    unsubscribeModalClose: AutoReplenishmentBindings.unsubscribeModalClose,
    skipModalClose: AutoReplenishmentBindings.skipModalClose,
    resumeModalConfirm: AutoReplenishmentBindings.resumeModalConfirm,
    addCardModalClose: AutoReplenishmentBindings.addCardModalClose,
    skipConfirmation: AutoReplenishmentBindings.skipConfirmation,
    loadMoreTracking: AutoReplenishmentBindings.loadMore,
    loadContentfulContent: AutoReplenishmentActions.loadContentfulContent,
    openRemoveAddressModal: AutoReplenishmentActions.openRemoveAddressModal,
    openLimitReachedModal: AutoReplenishmentActions.openLimitReachedModal,
    getSavedAddresses: AddressActions.getSavedAddresses,
    setDefaultAddress: AddressActions.setDefaultAddress,
    deleteSavedAddress: AddressActions.deleteAddress,
    updateDefaultShippingAddressData: AddressActions.updateDefaultShippingAddressData,
    updateSubscriptionAddress: AutoReplenishmentActions.updateSubscriptionAddress,
    loadSubscription: AutoReplenishmentActions.loadSubscription,
    refreshSubscriptions: AutoReplenishmentActions.refreshSubscriptions,
    orderNow: AutoReplenishmentActions.orderNow,
    openOrderConfirmationModal: AutoReplenishmentActions.openOrderConfirmationModal,
    openOrderConfirmationFailure: AutoReplenishmentActions.openOrderConfirmationFailure,
    openOrderNowTooSoonModal: AutoReplenishmentActions.openOrderNowTooSoonModal
};

const withAutoReplenishmentProps = wrapHOC(connect(null, functions));

export {
    withAutoReplenishmentProps, functions
};
